import e from"react";import o from"styled-components";import{calculateRem as t}from"@vds-core/utilities";import{Body as r}from"@vds-core/typography";const l=o.div.withConfig({displayName:"InputTextWrapper",componentId:"VDS__sc-r9e0ad-0"})`
  display: block;
  margin-top: ${t(8)};
`,i=({children:o,fontFamily:t,color:i})=>e.createElement("div",{role:"alert"},e.createElement(l,null,e.createElement(r,{size:"small",fontFamily:t&&t,color:i},o)));export{i as default};
